import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TeamScore {
  score: number;
  totalCards: number;
  znkCount: number;
  has2ofClub: boolean;
  has10ofDiamond: boolean;
}

interface GameSummaryState {
  team1Score: TeamScore;
  team2Score: TeamScore;
  gameId: string;
  winner: string;
}

const initialState: GameSummaryState = {
  team1Score: { score: 0, totalCards: 0, znkCount: 0, has2ofClub: false, has10ofDiamond: false },
  team2Score: { score: 0, totalCards: 0, znkCount: 0, has2ofClub: false, has10ofDiamond: false },
  gameId: "",
  winner: ""
};

const gameSummarySlice = createSlice({
  name: "gameSummary",
  initialState,
  reducers: {
    setGameData: (
      state,  // now this will mutate state directly
      action: PayloadAction<{ gameData: GameSummaryState }>
    ) => {
      // Now mutate the state directly
      state.team1Score = action.payload.gameData.team1Score;
      state.team2Score = action.payload.gameData.team2Score;
      state.gameId = action.payload.gameData.gameId;
      state.winner = action.payload.gameData.winner;
    },

    resetGame: () => initialState,

    updateTeam1Score: (state, action: PayloadAction<Partial<TeamScore>>) => {
      state.team1Score = { ...state.team1Score, ...action.payload };
    },

    updateTeam2Score: (state, action: PayloadAction<Partial<TeamScore>>) => {
      state.team2Score = { ...state.team2Score, ...action.payload };
    },

    setWinner: (state, action: PayloadAction<string>) => {
      state.winner = action.payload;
    }
  }
});

export const {
  setGameData,
  resetGame,
  updateTeam1Score,
  updateTeam2Score,
  setWinner
} = gameSummarySlice.actions;

export default gameSummarySlice.reducer;
